module.exports = __webpack_public_path__ + "curriculum-f5a47a7ed0fe08f6c0aafd70c32b8939.png";